<!-- <div *ngIf="uploadInProgress" class="progress-container">
  <div class="progress-bar" [style.width.%]="uploadProgress"></div>
  <div class="progress-text">{{ uploadProgress }}%</div>
  <div class="progress-text">{{ uploadMB}}%</div>
</div> -->

<div *ngIf="uploadInProgress" class="overlayDiv"  >

  <div class="progressinnerContainer">  <div  class="progress-container">
    <div class="progress-bar" [style.width.%]="uploadProgress"></div>
    <div class="progress-text">{{ uploadProgress }}%</div>
    <div class="progress-text">{{ uploadMB}}</div>
  </div></div>
 
</div>